import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { BaseStore } from 'src/store';
import { useLocale } from 'src/modules/locale';
import { ProductEntity } from 'src/modules/products';
import { LayoutDynamicZone } from 'src/modules/layout';
import styles from './ProductsDetailsOverlaySectionDetails.module.scss';

interface ProductsDetailsOverlaySectionDetailsProps {
  product: ProductEntity;
}

const ProductsDetailsOverlaySectionDetails: React.FunctionComponent<ProductsDetailsOverlaySectionDetailsProps> = (
  props: ProductsDetailsOverlaySectionDetailsProps
) => {
  const { getLocalizedObject } = useLocale();
  const { product } = getLocalizedObject(props);

  return (
    <div className={styles.container}>
      <h3>
        <FormattedMessage id="page/products/details/details" />
      </h3>
      <section>
        <LayoutDynamicZone components={product.product_details_overlay} />
      </section>
    </div>
  );
};

const mapStateToProps = (state: BaseStore) => {
  return { product: state.products.details?.product };
};

export default connect(mapStateToProps)(ProductsDetailsOverlaySectionDetails);
